import { useTranslationWithPrefix } from '@hotjar/translations';
import { Icon } from '@hotjar/hotsauce';

import * as S from './styles';

interface Props {
  onClick: () => unknown;
  isOpen: boolean;
}

export const PlanFeaturesToggle = ({ onClick, isOpen }: Props): JSX.Element => {
  const { t } = useTranslationWithPrefix('revenue:plan-comparison-columns');

  // FIXME: This clickable div is not accessible. It should be a button.
  return (
    <S.FeaturesToggle
      direction="row"
      spacing="x1pt5"
      onClick={onClick}
      data-testid="plan-comparison-features-toggle"
    >
      {isOpen ? t('show-less') : t('show-features')}
      <Icon icon={isOpen ? 'chevron_top' : 'chevron_bottom'} size="m" color="text_default" />
    </S.FeaturesToggle>
  );
};
